module.exports = __webpack_public_path__ + "img/banner-tc1-m.f5d87ed7.jpg";